<template>
  <div class="inputfield" :class="cls">
    <label>{{label}}</label>
    <slot></slot>
    <div class="suffix" v-if="suffix">{{suffix}}</div>
    <svgicon v-if="icon" :icon="icon"></svgicon>
  </div>
</template>

<script>
//import './../components/generated_svg_icons/'
export default {
  name: 'inputfield',
  props: {
    label: { type:String },
    icon: { type:String },
    type: { type:String },
    suffix: { type:String },
    padded: { type:Boolean, default:false },
    classes: { type:String },
  },
  data(){
    return {
    }
  },
  computed: {
    
    cls(){
      var c = ''      
      if( this.$props.classes ) c += ' '+this.$props.classes+' '
      if( this.$props.padded ) c += ' padded '
      if( !this.$props.label ) c += ' no-label '
      return c
    },

  },
  components: { },
}
</script>



// WEBPACK FOOTER //
// Inputfield.vue?3852e101